import APU from "../assets/images/apu.webp";
import Curtin from "../assets/images/curtin-malaysia.webp";
import Heriot from "../assets/images/heriot-watt-university-malaysia.webp";
import Segi from "../assets/images/segi.webp";
import Help from "../assets/images/help.webp";
import Iglobal from "../assets/images/iglobal.webp";
import Manipal from "../assets/images/manipal-university-college.webp";
import MIA from "../assets/images/mia.webp";
import QIU from "../assets/images/qiu.webp";
import Raffles from "../assets/images/raffles-university.webp";
import UOSM from "../assets/images/university-of-southampton-malaysia.webp";
import YTL from "../assets/images/ytl.webp";
import UORM from "../assets/images/university-of-reading-malaysia.webp";
import UOC from "../assets/images/university-of-cyberjaya.webp";
import UOW from "../assets/images/university-of-wollongong.webp";
import PSB from "../assets/images/psb-academy.webp";
import Kaplan from "../assets/images/kaplan-singapore.webp";
import Amity from "../assets/images/amity-global-institute.webp";
import EAIM from "../assets/images/eaim.webp";
import MDIS from "../assets/images/mdis.webp";
import Teesside from "../assets/images/teesside-university.webp";
import UOSW from "../assets/images/university-of-south-wales.webp";
import UOS from "../assets/images/university-of-sunderland.webp";
import UWE from "../assets/images/uwe-bristol.webp";
import UOH from "../assets/images/university-of-huddersfield.webp";
import UON from "../assets/images/university-of-northampton.webp";
import Coventry from "../assets/images/coventry-university.webp";

export interface PartnerUniProps {
    uniName: string;
    uniLogo: string;
    location: string;
    type: "local" | "overseas";
    country: string;
    fields: string[];
    feeRange: string;
    scholarship: boolean;
}

export const PartnerUniData: PartnerUniProps[] = [
    //local partners
    {
        uniName: "Asia Pasific University (APU)",
        uniLogo: APU,
        location: "Kuala Lumpur",
        type: "local",
        country: "MY",
        fields: [
            "IT",
            "Business",
            "Accounting",
            "Engineering"
        ],
        feeRange: "RM 30,000 - 45,000 /year",
        scholarship: false,
    },
    {
        uniName: "Curtin University Malaysia",
        uniLogo: Curtin,
        location: "Miri, Sarawak",
        type: "local",
        country: "MY",
        fields: [
            "Engineering",
            "Business",
            "IT",
            "Health"
        ],
        feeRange: "RM 27,000 - 51,000 /year",
        scholarship: false,
    },
    {
       uniName: "Heriot-Watt University Malaysia",
       uniLogo: Heriot,
       location: "Putrajaya",
       type: "local",
       country: "MY",
       fields: [
        "Engineering",
        "Business",
        "Psychology",
        "IT"
       ],
       feeRange: "RM 39,000 - 55,000 /year", 
       scholarship: false,
    },
    {
       uniName: "SEGi University",
       uniLogo: Segi,
       location: "Petaling Jaya",
       type: "local",
       country: "MY",
       fields: [
        "Business",
        "Medicine",
        "Hospitality",
        "Education",
       ],
       feeRange: "RM 18,000 - 38,000 /year", 
       scholarship: false,
    },
    {
       uniName: "HELP University",
       uniLogo: Help,
       location: "Kuala Lumpur",
       type: "local",
       country: "MY",
       fields: [
        "Psychology",
        "Business",
        "Law",
        "Education"
       ],
       feeRange: "RM 20,000 - 40,000 /year", 
       scholarship: false,
    },
    {
       uniName: "IGlobal Academy",
       uniLogo: Iglobal,
       location: "Shah Alam",
       type: "local",
       country: "MY",
       fields: [
        "Business",
        "Accounting",
        "Education"
       ],
       feeRange: "RM 15,000 - 28,000 /year", 
       scholarship: false,
    },
    {
       uniName: "Manipal University College Malaysia",
       uniLogo: Manipal,
       location: "Melaka, Johor",
       type: "local",
       country: "MY",
       fields: [
        "Medicine",
        "Health",
        "Business",
        "Engineering"
       ],
       feeRange: "RM 20,000 - 60,000 /year", 
       scholarship: false,
    },
    {
       uniName: "Malaysian Institute of Art (MIA)",
       uniLogo: MIA,
       location: "Kuala Lumpur",
       type: "local",
       country: "MY",
       fields: [
        "Design",
        "Mass Communication",
        "Business",
        "Education"
       ],
       feeRange: "RM 16,000 - 30,000 /year", 
       scholarship: false,
    },
    {
       uniName: "Quest International University (QIU)",
       uniLogo: QIU,
       location: "Ipoh, Perak",
       type: "local",
       country: "MY",
       fields: [
        "Medicine",
        "Health",
        "Business",
        "Psychology"
       ],
       feeRange: "RM 18,000 - 42,000 /year",
       scholarship: false,
    },
    {
       uniName: "Raffles University",
       uniLogo: Raffles,
       location: "Johor",
       type: "local",
       country: "MY",
       fields: [
        "Design",
        "Business",
        "Psychology",
        "Education"
       ],
       feeRange: "RM 18,000 - 35,000 /year", 
       scholarship: false,
    },
    {
       uniName: "University of Southampton Malaysia",
       uniLogo: UOSM,
       location: "Johor",
       type: "local",
       country: "MY",
       fields: [
        "Engineering",
        "Business",
        "IT",
        "Education"
       ],
       feeRange: "RM 45,000 - 65,000 /year", 
       scholarship: false,
    },
    {
       uniName: "YTL International College of Management",
       uniLogo: YTL,
       location: "Kuala Lumpur",
       type: "local",
       country: "MY",
       fields: [
        "Hospitality",
        "Business",
        "Mass Communication",
        "Education"
       ],
       feeRange: "RM 20,000 - 35,000 /year", 
       scholarship: false,
    },
    {
       uniName: "University of Reading Malaysia",
       uniLogo: UORM,
       location: "Johor",
       type: "local",
       country: "MY",
       fields: [
        "Business",
        "Law",
        "Accounting",
        "Education"
       ],
       feeRange: "RM 35,000 - 55,000 /year", 
       scholarship: false,   
    },
    {
       uniName: "University of Cyberjaya",
       uniLogo: UOC,
       location: "Cyberjaya",
       type: "local",
       country: "MY",
       fields: [
        "Medicine",
        "Health",
        "Psychology",
        "Business"
       ],
       feeRange: "RM 22,000 - 55,000 /year", 
       scholarship: false,
    },
    {
       uniName: "University of Wollongong Malaysia",
       uniLogo: UOW,
       location: "Shah Alam, Pulau Pinang",
       type: "local",
       country: "MY",
       fields: [
        "IT",
        "Business",
        "Engineering",
        "Design"
       ],
       feeRange: "RM 25,000 - 45,000 /year", 
       scholarship: false,
    },
    //oversea partners
    {
       uniName: "PSB Academy",
       uniLogo: PSB,
       location: "Singapore",
       type: "overseas",
       country: "SG",
       fields: [
        "Business",
        "Accounting",
        "IT",
        "Engineering"
       ],
       feeRange: "SGD 13,000 – 25,000 /year", 
       scholarship: false,
    },
    {
       uniName: "Kaplan International Pathway",
       uniLogo: Kaplan,
       location: "Singapore",
       type: "overseas",
       country: "SG",
       fields: [
        "Business",
        "Accounting",
        "IT",
        "Psychology"
       ],
       feeRange: "SGD 12,000 - 24,000 /year", 
       scholarship: false,
    },
    {
       uniName: "Amity Global Institute",
       uniLogo: Amity,
       location: "Singapore",
       type: "overseas",
       country: "SG",
       fields: [
        "Business",
        "IT",
        "Psychology",
        "Mass Communication"
       ],
       feeRange: "SGD 11,000 - 30,000 /year", 
       scholarship: false,
    },
    {
       uniName: "East Asia Institute of Management",
       uniLogo: EAIM,
       location: "Singapore",
       type: "overseas",
       country: "SG",
       fields: [
        "Hospitality",
        "Business",
        "Accounting",
        "IT"
       ],
       feeRange: "SGD 10,000 - 22,000 /year", 
       scholarship: false,
    },
    {
       uniName: "Management Development Institute of Singapore",
       uniLogo: MDIS,
       location: "Singapore",
       type: "overseas",
       country: "SG",
       fields: [
        "Business",
        "Engineering",
        "IT",
        "Health"
       ],
       feeRange: "SGD 9,000 - 26,000 /year", 
       scholarship: false,
    },
    {
       uniName: "Teesside University",
       uniLogo: Teesside,
       location: "UK",
       type: "overseas",
       country: "UK",
       fields: [
        "IT",
        "Engineering",
        "Design",
        "Health"
       ],
       feeRange: "GBP 15,000 - 19,000 /year", 
       scholarship: false,
    },
    {
       uniName: "University of South Wales",
       uniLogo: UOSW,
       location: "UK",
       type: "overseas",
       country: "UK",
       fields: [
        "Engineering",
        "Design",
        "Business",
        "Mass Communication"
       ],
       feeRange: "GBP 14,000 - 17,500 /year", 
       scholarship: false,
    },
    {
       uniName: "University of Sunderland",
       uniLogo: UOS,
       location: "UK",
       type: "overseas",
       country: "UK",
       fields: [
        "Health",
        "Medicine",
        "Business",
        "Education"
       ],
       feeRange: "GBP 13,500 - 17,000 /year", 
       scholarship: false,
    },
    {
       uniName: "University of West England",
       uniLogo: UWE,
       location: "UK",
       type: "overseas",
       country: "UK",
       fields: [
        "Engineering",
        "IT",
        "Health",
        "Design"
       ],
       feeRange: "GBP 15,500 - 18,500 /year", 
       scholarship: false,
    },
    {
       uniName: "University of Huddersfield",
       uniLogo: UOH,
       location: "UK",
       type: "overseas",
       country: "UK",
       fields: [
        "Engineering",
        "Business",
        "IT",
        "Health"
       ],
       feeRange: "GBP 16,000 - 19,000 /year", 
       scholarship: false,
    },
    {
       uniName: "University of Northampthon",
       uniLogo: UON,
       location: "UK",
       type: "overseas",
       country: "UK",
       fields: [
        "Business",
        "Education",
        "Psychology",
        "Health"
       ],
       feeRange: "GBP 14,000 - 16,500 /year", 
       scholarship: false,
    },
    {
       uniName: "Coventry University",
       uniLogo: Coventry,
       location: "UK",
       type: "overseas",
       country: "UK",
       fields: [
        "Business",
        "Engineering",
        "Design",
        "IT"
       ],
       feeRange: "GBP 16,000 - 20,000 /year", 
       scholarship: false,
    },
]